import { createFileRoute } from "@tanstack/react-router";
import { OwnResident } from "@/components/app/portal/pages/own-resident";
import { ResidentBillingPage } from "@/components/app/portal/pages/resident-billing-page";

export const Route = createFileRoute("/resident-portal/billing")({
  head: () => ({ meta: [{ title: "Billing | People AI" }] }),
  component: ResidentBilling,
});

function ResidentBilling() {
  return <OwnResident>{(own) => <ResidentBillingPage residentId={own.residentId} />}</OwnResident>;
}
